
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/faq-migration",
      function () {
        return require("private-next-pages/docs/faq-migration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/faq-migration"])
      });
    }
  